import React, { useContext, useMemo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography, Alert } from 'foundations-library/components'
import { EsimContext } from 'providers'
import { useEsimOperationsContext } from '../../contexts/EsimOperationsContext'
import TerminateSimBtn from './TerminateSimBtn'
import UserForm from './UserForm'
import { getStatus } from './../../../utils/index'
import { details } from '../../../utils/objects'
import { ScreenSizeContext } from 'providers'
import UpdateSimButton from './UpdateSimBtn'

const useStyles = makeStyles(theme => {
    const smallScreen = (v) => v.mobile || v.tablet

    return {
        root: {
            padding: ({ screenSize }) => smallScreen(screenSize) ? '20px 20px 20px 20px' : '30px 70px 30px 20px',
            display: 'flex',
            flexDirection: ({ screenSize }) => smallScreen(screenSize) ? 'column' : 'row',
            maxWidth: '691px',
            margin: '0 auto',
            columnGap: '20px'
        },
        formContainer: {
            display: 'flex',
            flexDirection: 'column',
            rowGap: '10px',
            minWidth: 0,
            flexGrow: 1,
            '& .btn-container': {
                display: 'flex',
                columnGap: '1rem',
                margin: '20 auto'
            },
            '& [data-testid="select-select-toggle"] .ext-number': {
                display: 'none'
            }
        }
    }
})

/**
 *
 */
const AssignedForm = () => {
    const screenSize = useContext(ScreenSizeContext)
    const classes = useStyles({ screenSize })
    const { updatedEsim } = useContext(EsimContext)
    const { data, currentUser } = useEsimOperationsContext()

    const [statusText] = getStatus(data)

    const user = useMemo(() => {
        const isNxtUser = currentUser.user_tiered as boolean

        const user = data?.user
        let userName = `${user?.first_name} ${user?.last_name}`
        if (isNxtUser && user?.extension?.number) {
            userName = user?.extension?.name
            return `Ext ${user.extension.number}: ${userName}`
        }
        return userName
    }, [data])

    return (
        <div className={classes.root}>
            <Typography variant='subtitle1' color='neutral-500'>Assigned to:</Typography>
            <div className={classes.formContainer}>
                <Typography variant='subtitle1' color='neutral-900' data-testid='assigned-user-name'>{user}</Typography>
                <UserForm />
                {[
                    'Pending Device Activation',
                    'Termination Requested'
                ].includes(statusText) &&
                    <div className='btn-container'>
                        <UpdateSimButton />
                        <TerminateSimBtn size='large' />
                    </div>}
                {updatedEsim.error && <Alert level='error' icon={true}>{updatedEsim.error}</Alert>}
                {!updatedEsim.error && Boolean(Object.keys(updatedEsim.esim).length) && <Alert level='success' icon={true}>{details.updateSuccessMessage}</Alert>}
            </div>
        </div>
    )
}

export default AssignedForm
